import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'transworld-expedition-ship-truck',
  template: require('./transworld-expedition-ship-truck.component.html'),
  styles: [require('./../blog.component.scss'), require('./transworld-expedition-ship-truck.component.scss')]
})
export class TransworldExpeditionShipTruckComponent extends BlogPage {
  title = "Transworld Expedition uses Linescape to Ship Truck around the World - Linescape";
  description = "Linescape is a great tool to find container ships, when they leave, how long and what company.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/transworld-expedition-ship-truck/transworld-expedition-ship-truck.component.ts